import { APIModel } from '@shared/interfaces';

import { PollingStatus, StatusProvider } from '@/tax/models';

export class BudgetImport implements APIModel {
    id = -1;
    periodId = -1;
    reconciliationId = -1;
    budgetId = -1;
    budgetName = '';
    endDates = [''];
    ytdDate = '';
    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.periodId = data.period_id ?? -1;
        this.reconciliationId = data.reconciliation_id ?? -1;
        this.budgetId = data.budget_id ?? -1;
        this.budgetName = data.budget_name ?? '';
        this.endDates = data.end_dates ?? [];
        this.ytdDate = data.ytd_date ?? '';
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        return this;
    }

    serialize(): any {
        return {
            'period_id': this.periodId,
            'reconciliation_id': this.reconciliationId,
            'budget_id': this.budgetId,
            'budget_name': this.budgetName,
            'end_dates': this.endDates,
            'ytd_date': this.ytdDate,
        };
    }
}
